<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import settingsKeys from '../../../settings/settingsKeys.js';
    import { settingsGroupKeys } from '../pluginConfig.js';
    import Details from './generic/Details.svelte';
    import CheckMark from '../controls/generic/CheckMark.svelte';
    import MousePointerSetting from '../controls/MousePointerSetting.svelte';
    import { getIsNonDefaultState } from '../util.js';
    import { Icon } from '@oat-sa-private/ui-elements';
    import { __ } from '@oat-sa-private/ui-core';

    /**
     * Component of an a11y menu panel group
     */

    const groupKey = settingsGroupKeys.pointer;

    /**
     * @typedef {Object} Props
     * @property {Object} areaBroker
     * @property {Object} pluginConfig
     * @property {Object} initialSettingsState
     * @property {Function} onChange
     * @property {Function} onToggle
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        areaBroker,
        pluginConfig,
        initialSettingsState,
        onChange,
        onToggle
    } = $props();

    let nonDefault = $derived(getIsNonDefaultState(settingsKeys.mousePointer, initialSettingsState, pluginConfig));

    function handleChange(newState = {}) {
        nonDefault = newState?.state?.nonDefault;
        onChange?.(newState);
    }
</script>

<Details
    key={groupKey}
    config={pluginConfig[groupKey]}
    collapsed={initialSettingsState[groupKey]?.collapsed}
    outlined={nonDefault}
    ariaLabelCollapse={__('collapse pointer settings')}
    ariaLabelExpand={__('expand pointer settings')}
    {onToggle}>
    {#snippet summary()}
        <h3 class="ui-heading">
            <Icon name="pointer-16" ariaHidden />
            {__('Cursor')}
            {#if nonDefault}
                <CheckMark />
            {/if}
        </h3>
    {/snippet}
    {#if pluginConfig[settingsKeys.mousePointer]?.enabled}
        <ul>
            <li>
                <MousePointerSetting
                    {areaBroker}
                    initialState={initialSettingsState[settingsKeys.mousePointer]?.toolState}
                    onChange={handleChange} />
            </li>
        </ul>
    {/if}
</Details>
